import { Component, Input } from "@angular/core";

@Component({
    selector: "app-funding-item-settlement-table-cell-content",
    templateUrl: "./funding-item-settlement-table-cell-content.component.html",
    styleUrls: ["./funding-item-settlement-table-cell-content.component.less"],
    standalone: false
})
export class FundingItemSettlementTableCellContentComponent {

    @Input() columnId: string;
    @Input() element: any;

}
